<template>
    <div class="tli blocklist-row" :class="topicClass">
        <div class="standard">            
            <div class="col-indicators">
                <div class="icon-container">
                    <div v-if="isModerated"><img alt="moderated" title="Moderated Topic" class="tsi" src="/icons/topic/tsi-moderated.png" /></div>
                    <div v-if="isPinned"><img alt="pinned" title="Pinned Topic" class="tsi" src="/icons/topic/tsi-pinned.png" /></div>
                    <div v-if="isLocked"><img alt="locked" title="Locked Topic" class="tsi" src="/icons/topic/tsi-locked.png" /></div>              
                    <div v-if="isParticipating"><img alt="participating" title="Participating Topic" class="tsi" src="/icons/topic/tsi-participating.png" /></div>
                </div>
            </div>
            <div class="col-status">   
                <div class="icon-container">
                    <img :title="statusTooltip" :src="topicIcon"/>
                </div>
            </div>
            <div class="col-topic">
                <router-link :class="readUnreadClass" :to="{ path: '/topics/' + topic.topicID + '?post=unread'}">{{ topic.title | decodeHtml }}</router-link>
            </div>
            <div class="col-board">
                <router-link :to="{ path: '/boards/' + topic.boardID }">{{ topic.boardName | decodeHtml }}</router-link>
            </div>
            <div class="col-started-by">
                <router-link :to="{path: '/members/' + topic.startedByMemberID}">{{ topic.startedByMemberDisplayName }}</router-link>
            </div>
            <div class="col-replies">
                {{ topic.replies }}
            </div>
            <div class="col-views">
                {{ topic.views | formatNumber }}
            </div>
            <div class="col-last-action">
                <div class="timestamp">{{ topic.latestPostDateUTC | localDateTime }}</div>
                <div class="member"><span class="last-post-by">Last Post by:</span> <router-link :to="{path: '/members/' + topic.latestPostByMemberID}">{{ topic.latestPostByMemberDisplayName }}</router-link></div>
            </div>
        </div>        
        <div class="mobile">
            <div class="col-status"><img :src="topicIcon"/></div>
            <div class="tli-content">
                <div class="col-topicinfo"><router-link :class="readUnreadClass" :to="{ path: '/topics/' + topic.topicID + '?post=unread'}">{{ topic.title | decodeHtml }}</router-link></div>
                <div class="col-startinfo">
                    Started by {{ topic.startedByMemberDisplayName }}, {{topic.replies}} replies, {{topic.views}} views
                </div>
                <div class="col-latestinfo">
                    Last post by {{ topic.latestPostByMemberDisplayName }} on {{ topic.latestPostDateUTC | localDateTime }}
                </div>
            </div>            
        </div>
    </div>    
</template>

<script>

    import topicHelper from '../../modules/topics/statusHelper'

    export default {        
        props: ['topic'],
        computed: {
            topicClass() {
                return topicHelper.getClass(this.topic.status);   
            },
            readUnreadClass() {
                if (this.isUnread) {
                    return "topic-title-unread";
                } else {
                    return "topic-title-read";
                }
            },
            topicIcon() {
                var theme = localStorage.getItem('theme');                
                if (this.isUnread) {
                    if (theme === 'dark') {
                        return '/icons/topic/unread-dark.png'
                    } else {
                        return '/icons/topic/unread.png'
                    }
                    
                } else {
                    if (theme === 'dark') {
                        return '/icons/topic/read-dark.png'    
                    } else {
                        return '/icons/topic/read.png'
                    }
                    
                }
            },
            statusTooltip() {
                if (this.isUnread) {
                    return "Unread Posts in this Topic";
                } else {
                    return "No new posts in this topic";
                }
            },
            isParticipating() { return this.topic.participated },
            isLocked() { return this.topic.status === 4 },
            isModerated() { return this.topic.status === 3 },
            isPinned() { return this.topic.pinned },
            isUnread() { return !this.topic.memberRead; }
        },
        mounted() {
            
        }
    }
</script>

